import { apiClient } from "./api";
import type { OIDCConfig } from "@/lib/oidc";

export interface User {
  id: string;
  email: string;
  name: string;
  tenant_id: string;
  roles: string[];
}

export async function getCurrentUser(): Promise<User> {
  const response = await apiClient.get("/auth/me");
  return response.data.user;
}

export async function login(account: string, password: string): Promise<string> {
  const response = await apiClient.post("/auth/login", { account, password });
  const token = response.data.access_token;
  localStorage.setItem("access_token", token);
  return token;
}

export async function oidcCallback(code: string, redirectUri: string): Promise<string> {
  const codeVerifier = sessionStorage.getItem("facet_oidc_code_verifier") || "";
  const response = await apiClient.post("/auth/oidc/callback", {
    code,
    redirect_uri: redirectUri,
    code_verifier: codeVerifier,
  });
  const token = response.data.access_token;
  localStorage.setItem("access_token", token);
  return token;
}

export async function getOIDCConfig(options: { forLogin?: boolean } = {}): Promise<OIDCConfig> {
  // forLogin=true 表示这次调用后就要拿 authorize_url 跳转登录：后端据此消费
  // 登出时种下的 relogin 标记，在 authorize_url 上追加 prompt=login（F 强制重验凭据）。
  const response = await apiClient.get("/auth/oidc/config", {
    params: options.forLogin ? { for_login: true } : undefined,
    withCredentials: true,
  });
  return response.data;
}

export async function logout(): Promise<void> {
  localStorage.removeItem("access_token");
  try {
    // 通知后端种 5 分钟 relogin 标记，避免下一次登录被 F 侧仍有效的 SSO 会话秒放行。
    await apiClient.post("/auth/logout", null, { withCredentials: true });
  } catch {
    // 后端不可达不阻断本地登出（令牌已清）
  }
}
